import {
  HeartHandshake,
  PencilRuler,
  Wrench,
  ShieldCheck,
  Cpu,
  LifeBuoy,
  BadgeIndianRupee,
  Users,
} from "lucide-react";

const FEATURES = [
  {
    icon: HeartHandshake,
    title: "Professional Consultation",
    desc: "Honest guidance from solar experts who put your goals first.",
    color: "#0F4C81",
  },
  {
    icon: PencilRuler,
    title: "Customized System Design",
    desc: "Every system is sized and engineered for your roof & usage.",
    color: "#F6B800",
  },
  {
    icon: Wrench,
    title: "Expert Installation",
    desc: "Certified technicians ensuring safe, code-compliant installs.",
    color: "#2E8B57",
  },
  {
    icon: ShieldCheck,
    title: "High-Quality Components",
    desc: "Tier-1 panels, inverters and structures — built to last.",
    color: "#0F4C81",
  },
  {
    icon: Cpu,
    title: "Enphase Microinverters",
    desc: "Module-level performance, safety, and monitoring built-in.",
    color: "#F6B800",
  },
  {
    icon: LifeBuoy,
    title: "Reliable After-Sales",
    desc: "Maintenance, monitoring & quick response when you need it.",
    color: "#2E8B57",
  },
  {
    icon: BadgeIndianRupee,
    title: "Affordable & Transparent",
    desc: "Clear, honest pricing — no surprises, no hidden costs.",
    color: "#0F4C81",
  },
  {
    icon: Users,
    title: "Experienced Team",
    desc: "Years of hands-on experience across Kerala solar projects.",
    color: "#F6B800",
  },
];

export const Features = () => {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="relative py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="chapter-label tt-reveal" data-testid="features-chapter-label"><span>03 / THE DIFFERENCE IS IN THE DETAILS</span><span>WHY TECH THRISSUR</span></div>
        <div className="section-intro tt-reveal"><div><h2 className="eyebrow" data-testid="features-heading">WHY CHOOSE US</h2><p className="section-statement" data-testid="features-statement">Built with care.<br /><span>Backed for life.</span></p></div><p>Good energy starts with good people. Here’s what we bring to every rooftop, every project, every conversation.</p></div>

        <div className="feature-grid">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return <div key={f.title} data-testid={`feature-card-${i}`} className="feature-card tt-reveal">
              <div className="feature-top"><Icon size={29} strokeWidth={1.4} /><span className="eyebrow">0{i + 1}</span></div>
              <h3>{f.title}</h3><p>{f.desc}</p>
            </div>;
          })}
        </div>
      </div>
    </section>
  );
};
